import { render, staticRenderFns } from "./ValorMonetario.vue?vue&type=template&id=7bf928a3&scoped=true&"
import script from "./ValorMonetario.vue?vue&type=script&lang=js&"
export * from "./ValorMonetario.vue?vue&type=script&lang=js&"
import style0 from "./ValorMonetario.vue?vue&type=style&index=0&id=7bf928a3&scoped=true&lang=css&"
import style1 from "./ValorMonetario.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf928a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
